module.exports = __webpack_public_path__ + "bz.41fe018eae278a405f0a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bz.svg
// module chunks = styles